import React from 'react'
import { BackButton, BackInfoWrap, InfoButton } from './index.styled'

const BackInfo = React.memo(({  onClickInfo, onClickBack, backAbility, infoAbility, outline, size, color }) => {
	const layout =  (size ? ' ' + size : '')

	return (
		<BackInfoWrap className={(backAbility ? 'double ' : '') + layout}>
			{backAbility &&
				<BackButton className={'back ' + layout} onClick={onClickBack} data-testid="back">
					<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
						<path d="M21.9 9.1C20.2 7.4 17.9 6.5 15.5 6.5H6.2L10.1 2.6L8 0.5L0.5 8L8 15.5L10.1 13.4L6.2 9.5H15.5C17.1 9.5 18.6 10.1 19.7 11.3C20.8 12.4 21.5 13.9 21.5 15.5C21.5 17.1 20.9 18.6 19.7 19.7C18.6 20.9 17.1 21.5 15.5 21.5H9.5V24.5H15.5C17.9 24.5 20.2 23.6 21.9 21.9C23.6 20.2 24.5 17.9 24.5 15.5C24.5 13.1 23.6 10.8 21.9 9.1Z" fill="white" />
					</svg>
				</BackButton>}
			{infoAbility && <InfoButton className={'info ' + layout} onClick={onClickInfo} data-testid="info">
				<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
					<path d="M12.5 0.5C5.84545 0.5 0.5 5.84545 0.5 12.5C0.5 19.1545 5.84545 24.5 12.5 24.5C19.1545 24.5 24.5 19.1545 24.5 12.5C24.5 5.84545 19.1545 0.5 12.5 0.5ZM14.6818 17.9545C14.6818 19.1545 13.7 20.1364 12.5 20.1364C11.3 20.1364 10.3182 19.1545 10.3182 17.9545V13.0455C10.3182 11.8455 11.3 10.8636 12.5 10.8636C13.7 10.8636 14.6818 11.8455 14.6818 13.0455V17.9545ZM12.5 8.13636C11.3 8.13636 10.3182 7.15455 10.3182 5.95455C10.3182 4.75455 11.3 3.77273 12.5 3.77273C13.7 3.77273 14.6818 4.75455 14.6818 5.95455C14.6818 7.15455 13.7 8.13636 12.5 8.13636Z" fill="white" />
				</svg>
			</InfoButton>}
		</BackInfoWrap>
	)
})

BackInfo.displayName = 'BackInfo'
export default BackInfo
